import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ru from 'vuetify/es5/locale/ru';

Vue.use(Vuetify);
export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#e62e2e',
        secondary: '#546e7a',
        accent: '#29434e',
        error: '#ba000d',
        info: '#819ca9',
        success: '#4CAF50',
        warning: '#ff9800',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { ru },
    current: 'en',
  },
});
